module.exports = __webpack_public_path__ + "img/famous-3.006a638d.png";